import { HTMLAttributes } from 'react';
import { FontStyle } from '../../../../enums';
import { joinClassNames } from '../../../../utils';
import { getClassForFontStyle } from '../utils';
import styles from './styles.module.scss';

type HeadingLevel = 1 | 2 | 3 | 4 | 5 | 6;

type HeadingTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export type HeadingProps = HTMLAttributes<HTMLHeadingElement> & {
  level: HeadingLevel;
  renderAs?: FontStyle;
};

/** @deprecated 14 Jul 2021 */
export const Heading = ({ children, level, renderAs }: HeadingProps) => {
  const ElementTag = `h${level}` as HeadingTag;
  const fontStyle = renderAs || (`heading${level}` as FontStyle);

  return (
    <ElementTag className={joinClassNames(styles.heading, getClassForFontStyle(fontStyle))}>
      {children}
    </ElementTag>
  );
};
